import { useMutation } from '@tanstack/react-query'

import useNotyf from '@/hooks/useNotyf'
import { useShowGenericServerError } from '@/hooks/useShowGenericServerError'
import { API_VIOLATION_CODE, LONG_MESSAGE_DURATION } from '@/lib/constants'
import constraintViolationService from '@/lib/services/constraintViolationService'
import serviceService from '@/lib/services/serviceService'

interface Options {
  onSuccess?: () => void
  onError?: () => void
  onMutate?: () => void
}

export function useDeleteServiceMutation({
  onSuccess,
  onError,
  onMutate,
}: Options) {
  const notyf = useNotyf()
  const showGenericServerError = useShowGenericServerError()

  return useMutation({
    mutationFn: async (serviceId: number) =>
      serviceService.deleteService(serviceId),
    onMutate: onMutate,
    onSuccess: onSuccess,
    onError: (error) => {
      const cannotDeleteServiceReason =
        constraintViolationService.getViolationByCode(
          error,
          API_VIOLATION_CODE.cannotDeleteService,
        )

      if (cannotDeleteServiceReason) {
        notyf.open({
          type: 'error',
          message: `Cannot delete service. ${cannotDeleteServiceReason.message}`,
          duration: LONG_MESSAGE_DURATION,
        })
      } else {
        showGenericServerError()
      }

      if (onError) {
        onError()
      }
    },
  })
}
